import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DayPicker from 'react-day-picker';

import ContactActions from '../actions/contact';
import { trackEvent } from '../helpers';

export default function CheckAvailability({
  userId = null,
  vendorId,
  type,
  location,
}) {
  const dispatch = useDispatch();
  const handleDayClick = ({ vendorId, userId }) => wedding_date => {
    dispatch(
      ContactActions.cacheContactFields({
        wedding_date: wedding_date.toISOString().substr(0, 10),
      })
    );
    window.scrollTo({
      top: 999999,
      left: 0,
      behavior: 'smooth',
    });
    trackEvent({
      event: 'show-contact-form',
      userId: userId,
      vendorId: vendorId,
    });
  };

  return (
    <DayPicker
      onDayClick={handleDayClick({ userId, vendorId, type, location })}
      numberOfMonths={2}
      pagedNavigation
      fixedWeeks
    />
  );
}
